import { useNavigate, Link } from 'react-router-dom';
import { usePrograms, useDeleteProgram } from '../hooks/usePrograms';
import { useAuth } from '../contexts/AuthContext';

export function ProgramListPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { data: programs, isLoading, isError, error } = usePrograms(isAuthenticated);
  const deleteProgram = useDeleteProgram();

  if (!isAuthenticated) {
    return (
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem', textAlign: 'center' }}>
        <p>Please <Link to="/login">log in</Link> to view your programs.</p>
      </div>
    );
  }

  if (isLoading) {
    return <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem', textAlign: 'center' }}>Loading programs...</div>;
  }

  if (isError) {
    const errMsg = error instanceof Error ? error.message : String(error);
    return <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem' }}>Error loading programs: {errMsg}</div>;
  }

  const handleDelete = async (programId: string, title: string) => {
    if (!window.confirm(`Delete "${title}"? This cannot be undone.`)) return;
    try {
      await deleteProgram.mutateAsync(programId);
    } catch (err) {
      alert(`Failed to delete program: ${err instanceof Error ? err.message : 'Unknown error'}`);
    }
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h1 style={{ margin: 0 }}>My Programs</h1>
        <button onClick={() => navigate('/programs/new')} className="btn btn-primary">
          + New Program
        </button>
      </div>

      {!programs || programs.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#666' }}>
          <p style={{ fontSize: '1.1rem', marginBottom: 'var(--spacing-md)' }}>No programs yet!</p>
          <p style={{ marginBottom: 'var(--spacing-lg)' }}>Create one to build an evening's set list.</p>
          <div style={{ display: 'flex', gap: 'var(--spacing-md)', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={() => navigate('/programs/new')} className="btn btn-primary">Create Program</button>
            <button onClick={() => navigate('/programs/generate')} className="btn" style={{ backgroundColor: 'var(--color-success)', color: 'white' }}>Generate with AI</button>
          </div>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '1rem' }}>
          {programs.map(program => (
            <div key={program.programId} className="card" style={{ backgroundColor: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <Link to={`/programs/${program.programId}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                  <h3 style={{ margin: 0 }}>{program.title}</h3>
                </Link>
                {program.description && <p style={{ margin: '0.25rem 0 0', color: '#666', fontSize: '0.9rem' }}>{program.description}</p>}
                <div style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: '#888' }}>
                  {program.dances.length} dance{program.dances.length !== 1 ? 's' : ''}
                  {program.isPublic && <span style={{ marginLeft: '0.5rem', color: '#28a745' }}>• Public</span>}
                </div>
              </div>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <button onClick={() => navigate(`/programs/${program.programId}/edit`)} className="btn btn-warning" style={{ fontSize: '0.875rem' }}>
                  Edit
                </button>
                <button onClick={() => handleDelete(program.programId, program.title)} className="btn btn-danger" style={{ fontSize: '0.875rem' }}>
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
